import { render, staticRenderFns } from "./LevelUp.vue?vue&type=template&id=1e5df0a4&scoped=true"
import script from "./LevelUp.vue?vue&type=script&lang=ts"
export * from "./LevelUp.vue?vue&type=script&lang=ts"
import style0 from "./LevelUp.vue?vue&type=style&index=0&id=1e5df0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5df0a4",
  null
  
)

export default component.exports